// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2zPmf","topBottomGutter":"Layout_topBottomGutter__IhSOo"};